import React, { useContext } from 'react'
import { Tooltip, useDrawer, Collapse } from './components'
import { HelpIcon, Included, NotIncluded, PencilIcon } from './assets'
import PlanEditCard from './PlanEdit'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { createOfferCart, getCoverageOptionName, getCoverageTooltip } from './utils'

export default ({ offer, options }) => {
  const { setOpen, Drawer, open } = useDrawer()
  const offersContext = useContext(BuyingInsuranceContextStore)
  const deductibleCoverages = ['Collision', 'Comprehensive']

  return (
    <>
      <div className="coverage-card">
        <div style={{ display: 'flex', marginBottom: '1rem' }}>
          <div style={{ fontSize: 13, fontWeight: 'bold', fontFamily: 'Poppins-Bold' }}>Coverages</div>
          <div style={{ marginLeft: 'auto' }}>
            <span style={{ color: '#2d2d2d', fontSize: '.8rem', marginRight: '.2rem' }} onClick={() => setOpen(true)}>
              Edit limits
            </span>
            <PencilIcon />
          </div>
        </div>
        {Object.keys(offer)
          .filter(c => offer[c].some(v => v.isInclude) && options[c].length > 1)
          .map(coverageName =>
            offer[coverageName].length === 1 ? (
              <div key={offer[coverageName][0].coverageOptionId} className="coverage-item">
                {offer[coverageName][0].isInclude ? <Included /> : <NotIncluded />}
                <div className="truncate" style={{ marginLeft: '0.3rem', ...(!offer[coverageName][0].isInclude && { color: '#e1dfdd' }) }}>
                  {offer[coverageName][0].title}
                </div>
                <div style={{ marginLeft: '0.3rem', marginRight: '0.5rem', position: 'relative' }}>
                  <Tooltip text={getCoverageTooltip(coverageName, options)}>
                    <HelpIcon />
                  </Tooltip>
                </div>
                <div className="truncate" style={{ marginLeft: 'auto', flexShrink: 0 }}>
                  {getCoverageOptionName(options, coverageName, offer[coverageName][0].coverageOptionId)}
                </div>
              </div>
            ) : (
              <Collapse
                key={offer[coverageName][0].coverageOptionId}
                open={`${3 * offer[coverageName].length}rem`}
                close="1.5rem"
                color="#717d84"
                title={
                  <div className="coverage-item">
                    {offer[coverageName].some(cov => cov.isInclude) ? <Included /> : <NotIncluded />}
                    <div style={{ marginLeft: '0.3rem' }}>{offer[coverageName][0].title}</div>
                    <div style={{ marginLeft: '0.3rem' }}>
                      <Tooltip text={getCoverageTooltip(coverageName, options)}>
                        <HelpIcon />
                      </Tooltip>
                    </div>
                    {deductibleCoverages.includes(offer[coverageName][0].title) && <div style={{ marginLeft: 'auto' }}>Deductibles</div>}
                  </div>
                }
              >
                {offer[coverageName].map(vehicleCoverage => (
                  <div key={vehicleCoverage.title} className="coverage-item">
                    <div className="truncate" style={{ marginLeft: '0.3rem' }}>
                      {vehicleCoverage.make} | {vehicleCoverage.model} | {vehicleCoverage.year}
                    </div>
                    <div style={{ marginLeft: 'auto' }}>
                      {getCoverageOptionName(options, coverageName, vehicleCoverage.coverageOptionId)}
                    </div>
                  </div>
                ))}
              </Collapse>
            )
          )}
        {/* not included coverages */}

        <Collapse
          close="1.5rem"
          color="#717d84"
          title={<div style={{ textDecoration: 'underline' }}>Excluded coverages</div>}
          open={`${Object.keys(offer).filter(c => offer[c].reduce((acc, v) => v.isInclude === false, false)).length * 2.8}rem`}
        >
          {Object.keys(offer)
            .filter(c => offer[c].every(c => !c.isInclude))
            .map(coverageName => (
              <div key={offer[coverageName][0].coverageOptionId} className="coverage-item">
                <NotIncluded />
                <div className="truncate" style={{ marginLeft: '0.3rem', ...(!offer[coverageName][0].isInclude && { color: '#e1dfdd' }) }}>
                  {offer[coverageName][0].title}
                </div>
                <div style={{ marginLeft: '0.3rem', marginRight: '0.5rem', position: 'relative' }}>
                  <Tooltip text={getCoverageTooltip(coverageName, options)}>
                    <HelpIcon />
                  </Tooltip>
                </div>
                <div className="truncate" style={{ marginLeft: 'auto', flexShrink: 0 }}>
                  {getCoverageOptionName(options, coverageName, offer[coverageName][0].coverageOptionId)}
                </div>
              </div>
            ))}
        </Collapse>
      </div>
      <Drawer height="calc(100% - 60px)">
        {Object.keys(offersContext.pricebreakdown).length > 0 && open && (
          <PlanEditCard
            offer={offersContext.pricebreakdown.vehicleCoveragePrices}
            options={options}
            addOnCoverages={offersContext.pricebreakdown.addOnCoveragePrices}
            startTime={offersContext.subscriptionStartTime}
            billingPeriodOffer={offersContext.billingPeriod}
            setOpen={setOpen}
          />
        )}
      </Drawer>
    </>
  )
}
